import {Brand, formatEuros} from "@mytour/platform";
import type {PaymentStatusPayload} from "@mytour/shared";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

type Props = {
  blocking: boolean;
  paymentStatus: PaymentStatusPayload;
  onFixRecurringPayment: (type: "monthly" | "yearly") => void;
  onDismiss: () => void;
};

export function FailedRecurringPaymentModal({
  blocking,
  paymentStatus,
  onFixRecurringPayment,
  onDismiss,
}: Props) {
  const amountEuros = formatEuros(paymentStatus.amount / 100);
  const subEuros = formatEuros(paymentStatus.subscriptionAmount / 100);
  const hasSms = paymentStatus.smsAmount > 0;

  return (
    <Modal
      isOpen={true}
      backdrop={blocking ? "static" : true}
      toggle={blocking ? undefined : onDismiss}
      autoFocus={false}
      centered
    >
      <ModalHeader
        close={blocking ? <></> : undefined}
        toggle={blocking ? undefined : onDismiss}
        className="mytour-header"
      >
        <Brand />
        Le paiement récurrent a échoué
      </ModalHeader>
      <ModalBody>
        <p style={{textAlign: "center"}}>
          <b>Merci de renouveler le paiement de l'abonnement</b>
        </p>
        <p style={{textAlign: "center"}}>
          {"Le paiement récurrent a échoué."}
          <br />
          {"Il est possible que votre carte soit "}
          <b>{"expirée"}</b>
          {" ou que le paiement récurrent soit impossible avec "}
          <b>{"cette carte"}</b>
          <br />
          {"Merci de choisir une autre carte ou contactez le support."}
        </p>
        {hasSms && (
          <p style={{textAlign: "center", color: "#6c757d", fontSize: "14px"}}>
            Abonnement {paymentStatus.orderKind === "yearly" ? "annuel" : "mensuel"} {subEuros} €
            <br />
            {formatSmsDetail(paymentStatus)}
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <div style={{textAlign: "center", margin: "auto", width: "100%"}}>
          <Button onClick={handleFixClick} color="primary">
            Régler {amountEuros} €
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );

  function handleFixClick() {
    onFixRecurringPayment(paymentStatus.orderKind === "sms" ? "monthly" : paymentStatus.orderKind);
  }
}

/** "42 SMS × 0,10 € = 4,20 €" or fallback "Notifications SMS 4,20 €" */
function formatSmsDetail(paymentStatus: PaymentStatusPayload): string {
  const smsEuros = formatEuros(paymentStatus.smsAmount / 100);
  if (paymentStatus.smsCount > 0 && paymentStatus.smsUnitPrice != null) {
    const unitPriceEuros = formatEuros(paymentStatus.smsUnitPrice);
    return `${paymentStatus.smsCount} SMS × ${unitPriceEuros} € = ${smsEuros} €`;
  }
  return `Notifications SMS ${smsEuros} €`;
}
